import Vue from 'vue'
import VueRouter from 'vue-router'

// 页面组件
import Home from '../views/Home.vue'
import StrategyManager from '../views/strategy.vue'
import TradingApp from '../views/TradingApp.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: '首页' }
  },
  {
    path: '/strategy',
    name: 'StrategyManager',
    component: StrategyManager,
    meta: { title: '策略管理' }
  },
  {
    path: '/trading/:strategyId?',
    name: 'Trading',
    component: TradingApp,
    meta: { title: '交易终端' }
  },
  {
    path: '*',
    redirect: '/strategy'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title ? `${to.meta.title} - SimuTrade` : 'SimuTrade'
  next()
})

export default router